export { default } from "./Skeleton";
export { default as Skeleton } from "./Skeleton";
export { default as TextSkeleton } from "./TextSkeleton";
export { default as AvatarSkeleton } from "./AvatarSkeleton";
export { default as CardSkeleton } from "./CardSkeleton";
export { default as TableSkeleton } from "./TableSkeleton";
export { default as PageSkeleton } from "./PageSkeleton";
